import { Component, OnInit, Input, OnDestroy, ViewChildren, Renderer, ViewEncapsulation, ViewChild } from '@angular/core';
import { Speaker } from '../models/speaker';
import { IterateObjectPipe } from '../iterate-object.pipe';
import { SpeakerService } from '../speaker.service';

import { Subscription } from 'rxjs/Subscription';

import {DataTable} from 'primeng/components/datatable/datatable';
import {Observable} from 'rxjs';

const TIMEOUT = 100;

@Component({
	selector: 'concordance',
	templateUrl: './concordance.component.html',
	styleUrls: ['./concordance.component.css'],
	encapsulation: ViewEncapsulation.None
})
export class ConcordanceComponent implements OnInit, OnDestroy {
	// console = console;
	@Input() instances: any[];
	@ViewChildren('cbx') checkboxes;
	@ViewChild('dt') dt: DataTable;
	
	selected = [];
	speaker_ids = [];
	name: boolean = false;
	role: boolean = false;
	age: boolean = false;
	gender: boolean = false;
	l1: boolean = false;
	country: boolean = false;
	proficiency: boolean = false;
	performance: boolean = false;
	
	
	concordanceGenderFilterSubscription: Subscription;
	concordanceProficiencyFilterSubscription: Subscription;
	concordanceAgeFilterSubscription: Subscription;
	concordanceMapFilterSubscription: Subscription;
	concordanceClearFilterSubscription: Subscription;
	concordanceCount = 10;
	
	name_filter: string;
	filterTimeout: any;
	
	
	constructor(private speaker: SpeakerService, private renderer: Renderer) {
		let self: ConcordanceComponent = this;
		speaker.instanceChange.subscribe((res) => {
			self.updateConcordanceCount({});
		});
	}
	
	ngOnInit() {
		let self: ConcordanceComponent = this;
		this.updateConcordanceCount({});
		this.concordanceGenderFilterSubscription = this.speaker.concordanceGenderFilter.subscribe(event => {
			// console.log(self.dt.filters, event);
			if (event.element) {
				self.speaker.concordanceClearFilter.next({});
				self.clearDT();
				setTimeout(() => {
					self.dt.filter(event.element._model.datasetLabel, 'speaker.Role', 'equals');
					self.dt.filter(event.element._model.label.toLowerCase(), 'speaker.Gender', 'equals');
					self.role = true;
					self.gender = true;
					self.searchWithFilters(self.dt);
				}, TIMEOUT);
			}
		});
		this.concordanceProficiencyFilterSubscription = this.speaker.concordanceProficiencyFilter.subscribe(event => {
			// console.log(self.dt.filters, event);
			if (event.element) {
				self.speaker.concordanceClearFilter.next({});
				self.clearDT();
				setTimeout(() => {
					self.dt.filter(event.element._model.datasetLabel, 'speaker.Role', 'equals');
					self.dt.filter(event.element._model.label.toLowerCase(), 'speaker.Proficiency', 'equals');
					self.role = true;
					self.proficiency = true;
					self.searchWithFilters(self.dt);
				}, TIMEOUT);
			}
		});
		this.concordanceAgeFilterSubscription = this.speaker.concordanceAgeFilter.subscribe(event => {
			// console.log(self.dt.filters, event);
			if (event.point) {
				self.speaker.concordanceClearFilter.next({});
				self.clearDT();
				setTimeout(() => {
					self.dt.filter(event.point.name, 'speaker.Name_', 'contains');
					self.name_filter = event.point.name.replace(/<\/?sub>/gi, '');
					self.name = true;
					self.searchWithFilters(self.dt);
				}, TIMEOUT);
			}
		});
		this.concordanceMapFilterSubscription = this.speaker.concordanceMapFilter.subscribe(event => {
			if (event.role) {
				self.speaker.concordanceClearFilter.next({});
				self.clearDT();
				setTimeout(() => {
					self.dt.filter(event.role, 'speaker.Role', 'equals');
					self.dt.filter(event.country, 'speaker.Country', 'equals');
					self.role = true;
					self.country = true;
					self.searchWithFilters(self.dt);
				}, TIMEOUT);
			}
		});
		this.concordanceClearFilterSubscription = this.speaker.concordanceClearFilter.subscribe(event => {
			setTimeout(() => {
				self.dt.reset();
				self.dt.filter('', 'speaker.Role', 'equals');
				self.dt.filter('', 'speaker.Proficiency', 'equals');
				self.dt.filter('', 'speaker.Gender', 'equals');
				self.dt.filter('', 'speaker.Name_', 'equals');
				this.speaker.concordanceGenderFilter.next({});
				this.speaker.concordanceProficiencyFilter.next({});
				this.speaker.concordanceAgeFilter.next({});
			}, 30);
		});
	}
	
	nameFilter(v: string) {
		if (this.filterTimeout) {
			clearTimeout(this.filterTimeout);
		}
		this.filterTimeout = setTimeout(() => {
			this.dt.filter(v, 'speaker.Name_', 'contains');
			// console.log(v, this.dt.filters);
			this.name_filter = v;
		}, 500);
	}
	
	private clearDT() {
		let self = this;
		self.name_filter = '';
		self.name = false;
		self.role = false;
		self.age = false;
		self.gender = false;
		self.l1 = false;
		self.country = false;
		self.proficiency = false;
		self.performance = false;
		// console.log(self.name_filter);
	}
	
	ngOnDestroy() {
		if (this.concordanceGenderFilterSubscription)
			this.concordanceGenderFilterSubscription.unsubscribe();
		if (this.concordanceProficiencyFilterSubscription)
			this.concordanceProficiencyFilterSubscription.unsubscribe();
		if (this.concordanceAgeFilterSubscription)
			this.concordanceAgeFilterSubscription.unsubscribe();
		if (this.concordanceClearFilterSubscription)
			this.concordanceClearFilterSubscription.unsubscribe();
	}
	/*
	  ngOnChanges() {
	  }
	*/
	switchInstance(event) {
		// this.speaker.switchInstance(this.cTable.first, event.data, event.originalEvent.checked);
	}
	
	switchInstances(event) {
		// this.speaker.switchInstances(event.checked);
	}
	
	exportCSV(dt) {
		let originalConc = [];
		let self = this;
		dt.value.forEach(row => {
			originalConc.push({r: row.concordance, left: row.concordance.leftDisplay, right: row.concordance.rightDisplay});
			row.concordance.leftDisplay = self.stripHTML(row.concordance.leftDisplay);
			row.concordance.rightDisplay = self.stripHTML(row.concordance.rightDisplay);
		});
		
		dt.exportCSV();
		
		originalConc.forEach(conc => {
			conc.r.leftDisplay = conc.left;
			conc.r.rightDisplay = conc.right;
		});
	}
	
	stripHTML(s: string) {
		let str = "";
		let insideTag = false;
		for (let i = 0; i < s.length; i++) {
			if (s.charAt(i) == '<')
				insideTag = true;
			
			if (s.charAt(i) == '>') {
				insideTag = false;
				continue;
			}
			
			if (!insideTag)
				str += s.charAt(i);
		}
		return str;
	}
	
	updateConcordanceCount(event) {
		this.speaker.instances.map(inst => {
			let left = inst['concordance']['left'],
				right = inst['concordance']['right'];
			let leftRemvl = left.length - this.concordanceCount;
			if (leftRemvl >= 0) {
				inst['concordance']['leftDisplay'] = this.buildDisplay(left.slice(left.length - this.concordanceCount), true);
			} else {
				inst['concordance']['leftDisplay'] = this.buildDisplay(left, true);
			}
			inst['concordance']['rightDisplay'] = this.buildDisplay(right.slice(0 , this.concordanceCount), false);
		});
	}
	
	printSpeaker(event) {
		console.log(event);
	}
	
	buildDisplay(concArray, isLHS) {
		if (concArray.length == 0) {
			return "";
		}
		let display = "";
		let isTarget;
		if (isLHS)
			isTarget = concArray[0].type == "ntrgt" ? true : false;
		else
			isTarget = concArray[0].type == "ntrgt" ? false : true;
		for (let i = 0; i < concArray.length; i++) {
			if (concArray[i].type == "ntrgt") {
				if (isTarget) {
					if (this.concordanceCount != 100 && i == 0)
						display += "<font color='blue'>" + concArray[i].ele + "</font> ";
					else
						display += "<font color='blue'>S: " + concArray[i].ele + "</font> ";
					isTarget = false;
				} else if (!isLHS && i == 0) {
					display += "<font color='blue'>S: " + concArray[i].ele + "</font> ";
				} else {
					display += "<font color='blue'>" + concArray[i].ele + "</font> ";
				}
			} else if (concArray[i].type == "trgt") {
				if (isTarget) {
					display += "<font color='black'>" + concArray[i].ele + "</font> ";
				} else if (this.concordanceCount != 100 && i == 0) {
					display += "<font color='black'>" + concArray[i].ele + "</font> ";
				} else {
					display += "<font color='black'>S: " + concArray[i].ele + "</font> ";
					isTarget = true;
				}
			}
		}
		return display.substring(0, display.length - 1);
	}
	
	concordanceSort(event, leftSort) {
		this.speaker.instances = [...this.speaker.instances.sort(function(a, b): number {
			let first;
			let second;
			if (leftSort) {
				first = a.concordance.left;
				second = b.concordance.left;
				let first_i = first.length - 1;
				let second_i = second.length - 1;
				while (first_i > -1 && second_i > -1) {
					let cmp = first[first_i].ele.localeCompare(second[second_i].ele);
					if (cmp < 0) {
						return -1 * event.order;
					} else if (cmp > 0) {
						return 1 * event.order;
					}
					first_i--;
					second_i--;
				}
				if (first_i < second_i) {
					return -1 * event.order;
				} else if (first_i > second_i) {
					return 1 * event.order;
				}
				return 0;
			} else {
				first = a.concordance.right;
				second = b.concordance.right;
				let first_i = 0;
				let second_i = 0;
				while (first_i < first.length && second_i < second.length) {
					let cmp = first[first_i].ele.localeCompare(second[second_i].ele);
					if (cmp < 0) {
						return -1 * event.order;
					} else if (cmp > 0) {
						return 1 * event.order;
					}
					first_i++;
					second_i++;
				}
				if (first.length < second.length) {
					return -1 * event.order;
				} else if (first.length > second.length) {
					return 1 * event.order;
				}
				return 0;
			}
		})];
	}
	
	ageSort(event) {
		this.speaker.instances = [...this.speaker.instances.sort(function(a, b): number {
			let age1 = Number(a.speaker.age);
			let age2 = Number(b.speaker.age);
			if (age1 < age2)
				return event.order * -1;
			else
				return event.order * 1;
		})];
	}
	
	searchWithFilters(dataTable: DataTable) {
		let concFilters = {};
		for (let f of Object.keys(dataTable.filters)) {
			let key = f.replace(/speaker\.|_/gi, '');
			let value: string;
			if (key === 'Name') {
				value = dataTable.filters[f].value.replace(/([a-zA-Z]+)(\d+)/gi, '$1<sub>$2</sub>');
			} else {
				value = dataTable.filters[f].value;
			}
			concFilters[key] = value;
		}
		this.speaker.searchFilter(concFilters).subscribe(res => {
			// console.log(res);
		});
	}
}




// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/concordance/concordance.component.ts